import common from '@/store/common/mutations';
import * as types from './mutation-types';

import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

import { SEARCH_PARAMS, CLAM_MST_POPUP, PAGING_INFO } from './state';

export default {
	...common,
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.clamMstList = []; //그리드리스트
		state.prcsStepList = []; //조회조건 처리단계
		state.prcsRsltList = []; //조회조건 처리결과
		state.pwaDdList = []; //조회조건 날자선택값
		state.gridPrcStepList = []; //그리드안에 사용여부
		state.popupSearchParams = POPUP_SEARCH_PARAM();
	},
	[types.STATE_APCN_INIT]: state => {
		state.clamMstPopUp = CLAM_MST_POPUP(); //디테일조회시
		state.savePwaApcn = CLAM_MST_POPUP(); //저장시
		state.clamMstSwapPartsList = []; //클레임신청팝업 교환부품정보
		state.fileList = []; //파일첨부
		state.occuRegnListPop = []; //클레임신청팝업 PWA기초 정보 발생지역
		state.causCdListPop = []; //클레임신청현황 PWA기초 정보 원인코드
		state.ctypeList = []; //클레임신청현황 PWA기초 정보 Ctype
		state.tgrpYnList = []; //클레임 신청현황 변제대상
		state.isSaveFlag = false;
		state.prcStateCd = '';
		state.tmpCustSaleDd = ''; //임시 고객판매일자
		state.tmpDgnDd = ''; //임시 진단일자.
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.APCN_INFO]: (state, { key, value }) => {
		state.clamMstPopUp[key] = value;
	},
	[types.CLAM_SAVE_INFO]: (state, { key, value }) => {
		state.saveClamMst[key] = value;
	},
	[types.POPUP_SEARCH_PARAM]: (state, payload) => {
		state.popupSearchParams[payload.key] = payload.value;
	}
};
